const scene = "plan-details/";
export const UPDATE_PLAN_DETAILS= `${scene}UPDATE_PLAN_DETAILS`;